import { createFileRoute, redirect } from "@tanstack/react-router";
import type { FC } from "react";
import { ForbiddenError } from "../../../../errors/ForbiddenError";
import { fetchTermsException } from "../../../../services/termsExceptions";
import { fetchVendor } from "../../../../services/vendors";
import { ShowTermsException } from "../terms_exceptions/$termExceptionId/-components/ShowTermsException";

const RouteComponent: FC = () => {
  const termsException = Route.useLoaderData();

  return <ShowTermsException termsException={termsException} />;
};

export const Route = createFileRoute(
  "/_private/vsupplierregistration/vendor/terms_exceptions",
)({
  beforeLoad: async ({ context }) => {
    const user = context.auth.user;

    if (!user?.vendor?.id) {
      throw new ForbiddenError();
    }

    const vendor = await fetchVendor(Number(user.vendor.id));

    if (!vendor.terms_exception) {
      throw redirect({
        params: {},
        replace: true,
        to: "/vsupplierregistration/vendor/terms",
      });
    }

    return { vendor };
  },
  component: RouteComponent,
  loader: ({ context: { vendor } }) => {
    const termsExceptionId = vendor.terms_exception?.id;

    if (!termsExceptionId) {
      throw redirect({
        params: {},
        replace: true,
        to: "/vsupplierregistration/vendor/terms",
      });
    }

    return fetchTermsException(termsExceptionId);
  },
});
